import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { lojaDaCampanha } from '../../config/publicidade';
import { observarExposicao } from '../../inteligencia/useImpressao';
import { registrarHouseAd } from '../../publicidade/rastreioHouseAds';

/**
 * Anúncio interno de uma loja integrada ao Super Vitrine (house ad).
 *
 * Só aparece no lugar de um bloco do Google comprovadamente vazio (AnuncioGrade decide).
 * Identidade própria e explícita: rótulo "Publicidade", marca oficial da loja, texto
 * simples e nenhuma menção ao Google.
 *
 * O destino é uma rota interna (ofertas da loja dentro do Super Vitrine). A saída para a
 * loja acontece depois, no card da oferta, pelo redirector com afiliação.
 *
 * Impressão: >= 50% visível por 500 ms (mesmo critério da coleta de exposição), uma vez
 * por placement na janela de 30 min. Clique: um evento por toque real (clique sintético
 * não conta). Os dois vão para /api/track/event com `source: 'house_ad'`, nunca para a
 * medição do AdSense nem para a coleta do IntelligenceEngine.
 */
export default function StoreAdCard({ campanha, posicao, placement }) {
    const loja = lojaDaCampanha(campanha);
    const dados = { campaign_id: campanha.campaign_id, store_id: campanha.store_id, placement, position: posicao };

    const refExposicao = useCallback((el) => {
        if (!el) return undefined;
        return observarExposicao(el, () => registrarHouseAd('house_ad_impression', dados));
    }, [campanha.campaign_id, placement, posicao]); // eslint-disable-line react-hooks/exhaustive-deps

    if (!loja) return null;
    const { marca } = loja;

    return (
        <div ref={refExposicao} className="sv-house-ad" data-testid={`house-ad-${campanha.campaign_id}`} data-store={campanha.store_id}>
            <span className="sv-anuncio-rotulo">Publicidade</span>
            <Link
                to={campanha.destination}
                className="sv-house-ad-link"
                onClick={(e) => registrarHouseAd('house_ad_click', dados, { confiavel: e.isTrusted === true })}
                data-testid="store-ad-link"
            >
                {campanha.imagem ? (
                    <img src={campanha.imagem} alt={loja.label} className="sv-house-ad-banner" loading="lazy" />
                ) : (
                    <span
                        className="sv-house-ad-marca"
                        style={{ '--loja-fundo': marca.fundo, '--loja-logo-h': `${marca.alturaLogo}px` }}
                    >
                        <img src={marca.logo} alt={loja.label} className="sv-house-ad-logo" loading="lazy" />
                    </span>
                )}
                <span className="sv-house-ad-texto">
                    <strong>{campanha.titulo}</strong>
                    {campanha.subtitulo && <small>{campanha.subtitulo}</small>}
                </span>
                <span className="sv-btn-action sv-house-ad-cta">{campanha.cta}</span>
            </Link>
        </div>
    );
}
